export class HotelAmenitiesService {
  static $inject = [];

  constructor() {}

  hasGuestLove(hotelDetail: any): boolean {
    return this.guestLoveList(hotelDetail).length > 0;
  }

  guestLoveList(hotelDetail: any): string[] {
    const goodToKnowList = hotelDetail?.trustyou?.reviews?.good_to_know_list;
    if (!goodToKnowList?.length) {
      return [];
    }
    return goodToKnowList.filter(comment => {
      return comment.sentiment === "pos";
    }).map(comment => {
      return comment.title;
    });
  }

  hasAmenities(hotelDetail: any): boolean {
    return hotelDetail && hotelDetail.amenities && Object.keys(hotelDetail.amenities).length > 0;
  }
}

angular.module("BookingApp").service("HotelAmenitiesService", HotelAmenitiesService);
